<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">edit</i>
                        </div>
                        <h4 class="card-title ">Editar</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-10">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.name != '', 'has-danger' : validation.name != '' }">
                                        <label for="name" class="bmd-label-floating">Nome *</label>
                                        <input refs="name" type="text" class="form-control" v-model="form.name" />
                                        <label v-if="validation.name != ''" id="name-error" class="error" for="name">{{ validation.name }}</label>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.deadline != '', 'has-danger' : validation.deadline != '' }">
                                        <label for="deadline" class="bmd-label-floating">Prazo</label>
                                        <input refs="deadline" type="text" class="form-control" v-model="form.deadline" />
                                        <label v-if="validation.deadline != ''" id="deadline-error" class="error" for="deadline">{{ validation.deadline }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.quotas != '', 'has-danger' : validation.quotas != '' }">
                                        <label for="quotas" class="bmd-label-floating">Cotas *</label>
                                        <input refs="quotas" type="text" v-numeric-only class="form-control" v-model="form.quotas" />
                                        <label v-if="validation.quotas != ''" id="quotas-error" class="error" for="quotas">{{ validation.quotas }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled"
                                         v-bind:class="{'has-danger' : validation.meeting_at != '' }">
                                        <label for="meeting_at" class="bmd-label-floating">Assembléia *</label>
                                        <date-picker v-model="computedDate" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data" :not-before="new Date()"></date-picker>
                                        <label v-if="validation.meeting_at != ''" id="meeting_at-error" class="error" for="meeting_at" style="clear: both; display: block;">{{ validation.meeting_at }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled"
                                         v-bind:class="{'has-danger' : validation.administrator_id != '' }">
                                        <label for="administrator_id" class="bmd-label-floating">Administradora *</label>
                                        <model-list-select 
                                            class="form-control"
                                            :list="administrators"
                                            v-model="form.administrator_id"
                                            option-value="id"
                                            option-text="name"
                                            placeholder="Escolha uma Administradora">
                                        </model-list-select>
                                        <label v-if="validation.administrator_id != ''" id="administrator_id-error" class="error" for="administrator_id" style="clear: both; display: block;">{{ validation.administrator_id }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons 
                                v-bind:to-back="{name: 'groups.index'}"
                                text-back="Voltar"
                                icon-back="keyboard_arrow_left" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    const moment = require('moment-timezone')

    export default {
        computed: {
            administrators: {
                set(_list) {

                },
                get() {
                    return this.$store.state.administrators.itens;
                }
            },
            computedDate: {
                get() {
                    return new Date(this.form.meeting_at + 'T23:59:59');
                },
                set(newValue) {
                    this.form.meeting_at = moment(newValue).format('YYYY-MM-DD');
                }
            },
            form: {
                set(_list) {

                },
                get() {
                    return this.$store.state.groups.item;
                }
            }
        },
        created() {
            var self = this;

            self.administrators = [];
            self.form = {
                name: '',
                quotas: '',
                meeting_at: '',
                administrator_id: ''
            };

            this.getData();
        },
        data() {
            return {
                validation: {
                    deadline: '',
                    name: '',
                    quotas: '',
                    meeting_at: '',
                    administrator_id: ''
                }
            };
        },
        methods: {
            onSubmit(_ev) {
                var valid = true;
                var self = this;

                self.validation.name = '';
                self.validation.quotas = '';
                self.validation.meeting_at = '';
                self.validation.administrator_id = '';

                if (self.form.name == '') {
                    self.validation.name = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.quotas == '') {
                    self.validation.quotas = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.meeting_at == '') {
                    self.validation.meeting_at = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.administrator_id == '') {
                    self.validation.administrator_id = 'Campo obrigatório!';
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit('onLoading');

                    const response = self.$store.dispatch('groups/edit', this.form);

                    response.then(function () {
                        self.$root.$emit('onLoading');
                        self.$notify.success("Grupo atualizado com sucesso!");
                        self.$router.push({'name': 'groups.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');
                        if (err.status === 422) {
                            if (err.data.errors.name !== undefined) {
                                self.validation.name = err.data.errors.name[0];
                            }

                            if (err.data.errors.quotas !== undefined) {
                                self.validation.quotas = err.data.errors.quotas[0];
                            }

                            if (err.data.errors.meeting_at !== undefined) {
                                self.validation.meeting_at = err.data.errors.meeting_at[0];
                            }

                            if (err.data.errors.administrator_id !== undefined) {
                                self.validation.administrator_id = err.data.errors.administrator_id[0];
                            }
                        }
                    });
                }

                _ev.preventDefault();
            },
            async getData() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('administrators/all');

                response.then(function () {
                    self.getDataGroup();
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');

                    self.$notify.error("Falha na comunicação com API!");
                    self.$router.push({'name': 'groups.index'});
                });
            },
            async getDataGroup() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('groups/get', this.$route.params.id);

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                    self.$router.push({'name': 'groups.index'});
                });
            }
        }
    };
</script>